/**
 * Copyright 2017 Control4 Corporation. All rights reserved.
 * Control4 Confidential and Proprietary Information.
 */

import { SCHEDULE_QUICKSTART_REDUCERS } from './quickstart-schedule/schedule-quickstart.store';
import { QUICKSTART_NOTIFICATIONS_REDUCERS } from './quickstart-notifications/notifications.store';
import { COMMON_PROGRAMMING_REDUCERS } from '../common/common.stores';
import { quickstartsReducer } from './services/quickstart-programming.service';
import { QUICKSTART_LIGHTS_REDUCERS } from './quickstart-lights/quickstart-lights.stores';
import { QUICKSTART_KEYPADS_REDUCERS } from './quickstart-keypads/quickstart-keypads.stores';
import { QUICKSTART_REMOTES_REDUCERS } from './quickstart-system-remotes/quickstart-remotes.stores';
import { QUICKSTART_SIMPLE_REDUCERS } from './quickstart-simple/quickstart-simple.store';
import { QUICKSTART_ROOMS_REDUCERS } from './quickstart-rooms/quickstart-rooms.store';
import { QUICKSTART_MEDIA_REDUCERS } from './quickstart-media/quickstart-media.store';
import { QUICKSTART_THERMOSTAT_REDUCERS } from './quickstart-thermostats/quickstart-thermostats.store';
import { eventsUIReducer } from './events/eventsUI.service';

export const QUICKSTART_PROGRAMMING_REDUCERS: any = Object.assign({},
  SCHEDULE_QUICKSTART_REDUCERS,
  QUICKSTART_LIGHTS_REDUCERS,
  QUICKSTART_LIGHTS_REDUCERS,
  QUICKSTART_KEYPADS_REDUCERS,
  QUICKSTART_NOTIFICATIONS_REDUCERS,
  QUICKSTART_REMOTES_REDUCERS,
  QUICKSTART_SIMPLE_REDUCERS,
  QUICKSTART_ROOMS_REDUCERS,
  QUICKSTART_MEDIA_REDUCERS,
  QUICKSTART_THERMOSTAT_REDUCERS,
  COMMON_PROGRAMMING_REDUCERS, {
    quickstartProgramming: quickstartsReducer,
    eventsUI: eventsUIReducer
  }
);



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstarts.stores.ts